module.exports = __webpack_public_path__ + "static/project-13a-0c4df22b53cf1b7eb9b93fb275f2e51b.png";